import React, { useMemo } from 'react';
import { MenuItem, TextField, Typography } from 'seagull';
import { defaultWidth } from "./constants";
export function CoverCreditCardFeesSelector(props) {
  const {
    value,
    className,
    vendorBusinessName,
    clientBusinessName,
    testid,
    width = defaultWidth,
    onChange,
    onOpen
  } = props;
  const options = useMemo(() => {
    return [{
      text: clientBusinessName || 'The client',
      value: 'false'
    }, {
      text: vendorBusinessName || 'The service provider',
      value: 'true'
    }];
  }, [vendorBusinessName, clientBusinessName]);
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(Typography, null, "Define who will pay the credit card processing fee"), /*#__PURE__*/React.createElement(TextField, {
    select: true,
    style: {
      marginBlockStart: 8
    },
    value: value,
    testid: testid && "".concat(testid, "-dropdown"),
    width: width,
    onChange: function (_onChange) {
      function onChange(_x) {
        return _onChange.apply(this, arguments);
      }
      onChange.toString = function () {
        return _onChange.toString();
      };
      return onChange;
    }(e => onChange(e.target.value === 'true')),
    onClick: onOpen
  }, options.map((option, idx) => /*#__PURE__*/React.createElement(MenuItem, {
    key: option.value,
    value: option.value,
    "data-testid": testid && "".concat(testid, "-option-").concat(idx)
  }, option.text))));
}